import React, { useState, useEffect } from 'react';
import SideBar from './Components/SideBar'; 
import { useNavigate } from 'react-router-dom';
import DatabaseUtil from './Util/DatabaseUtil';
import Panels from './Components/Panels'; 

const DashVideoSummary = () => {
    const navigate = useNavigate();
    const [videoDetailsList, setVideoDetailsList] = useState([]); 
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchAllVideoDetails = async () => {
            try {
                setLoading(true);
                const detailsList = await DatabaseUtil.getAllVideosDetails();
                setVideoDetailsList(detailsList);
            } catch (error) {
                console.error('Failed to fetch all video details:', error);
                setError('Failed to load video details.');
            } finally {
                setLoading(false);
            }
        };

        fetchAllVideoDetails();
    }, []);

    return (
        <>
            <SideBar />
            <div 
                style={{ 
                   /* marginLeft: '250px', 
                    padding: '20px', 
                    paddingTop: '100px', 
                    fontFamily: 'KomikaAxis', 
                    position: 'relative', 
                    overflowY: 'auto',
                    height: '100vh',*/
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <h2 style={{ marginBottom: '20px',  fontFamily: 'KomikaAxis', color: 'var(--primary-color)' }}>Videos</h2>
                {loading ? (
                    <p>Loading...</p>
                ) : error ? (
                    <p style={{ color: 'red' }}>{error}</p>
                ) : (
                    <div 
                        style={{ 
                            display: 'flex', 
                            flexDirection: 'column', 
                            gap: '20px',
                            alignItems: 'flex-start',
                        }}
                    >
                        {videoDetailsList.map((videoDetails, index) => (
                            <Panels 
                                type='video'
                                key={index}
                                videoDetails={videoDetails} 
                                onClick={() => navigate(`/video/${videoDetails.id}`)} 
                            />
                        ))}
                    </div>
                )}
            </div>
        </>
    );
};

export default DashVideoSummary;
